import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";

function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    await login(formData.email, formData.password);

    toast.success("Connexion réussie ! Redirection...", {
      position: "top-right",
      autoClose: 2000,
    });

    setTimeout(() => navigate("/"), 1800);
  } catch (error) {
    if (error.response?.status === 401) {
      toast.error("Identifiants incorrects.", {
        position: "top-right",
        autoClose: 5000,
      });
    } else {
      toast.error("Erreur réseau ou serveur.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  } finally {
    setLoading(false);
  }
};

  return (
<>
     <Helmet>
      <title>Connexion | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div className="min-h-screen bg-slate-950 px-4 py-10 text-slate-100">
      <div className="mx-auto max-w-3xl">
        <section className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-blue-900 text-white shadow-sm">
          <div className="p-8 md:p-10">
            <p className="mb-3 inline-flex rounded-full bg-white/10 px-3 py-1 text-sm font-medium text-blue-100">
              LMFP Photography
            </p>

            <h1 className="mb-3 text-3xl font-bold md:text-4xl">
              Connexion
            </h1>

            <p className="max-w-2xl text-sm leading-7 text-slate-200 md:text-base">
              Accédez à votre espace pour gérer votre profil, suivre vos
              activités et interagir avec la plateforme.
            </p>
          </div>
        </section>

        <section className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="rounded-2xl border border-slate-800 bg-slate-950 p-6">
              <h2 className="mb-5 text-lg font-semibold text-white">
                Informations de connexion
              </h2>

              <div className="space-y-6">
                <div>
                  <label
                    className="mb-2 block text-sm font-medium text-slate-200"
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="exemple@email.com"
                    required
                    autoFocus
                    value={formData.email}
                    onChange={handleChange}
                    className="block w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-slate-100 placeholder:text-slate-500 focus:border-blue-500 focus:outline-none"
                  />
                </div>

                <div>
                  <label
                    className="mb-2 block text-sm font-medium text-slate-200"
                    htmlFor="password"
                  >
                    Mot de passe
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="********"
                    required
                    value={formData.password}
                    onChange={handleChange}
                    className="block w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-slate-100 placeholder:text-slate-500 focus:border-blue-500 focus:outline-none"
                  />
                </div>

                <div className="flex justify-end">
                  <Link
                    to="/forgot-password"
                    className="text-sm text-slate-400 transition hover:text-white"
                  >
                    Mot de passe oublié ?
                  </Link>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row">
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-xl bg-blue-600 px-8 py-3 font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
              >
                {loading ? "Connexion..." : "Se connecter"}
              </button>
            </div>

            <div className="rounded-2xl border border-slate-800 bg-slate-950 p-6">
              <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-200">
                    Pas encore de compte ?
                  </p>
                  <p className="mt-1 text-sm text-slate-400">
                    Rejoignez la plateforme pour créer votre profil et
                    commencer à interagir.
                  </p>
                </div>

                <Link
                  to="/register"
                  className="inline-flex w-full items-center justify-center rounded-xl border border-slate-600 px-6 py-3 font-semibold text-slate-100 transition hover:bg-slate-800 hover:text-white sm:w-auto"
                >
                  Créer un compte
                </Link>
              </div>
            </div>
          </form>
        </section>

        <ToastContainer />
      </div>
    </div>
    </>
  );
}

export default Login;